import React from 'react';

const SpaceChar: React.FC = () => {
    return <span dangerouslySetInnerHTML={{ __html: '&nbsp' }} />;
}

export default SpaceChar;